import type { Crepe } from '@milkdown/crepe';
import { remarkStringifyOptionsCtx } from '@milkdown/kit/core';

import { highlightMarkdownHandler, highlightMdastUnsafe, textHighlightPlugin } from './plugin';

/**
 * Registers ==highlight== mark, remark parse/stringify, and toolbar toggle command.
 *
 * ```ts
 * configureHighlight(crepe);
 * ```
 */
export function configureHighlight(crepe: Crepe): void {
  textHighlightPlugin.forEach((plugin) => crepe.editor.use(plugin));
  crepe.editor.config((ctx) => {
    const prev = ctx.get(remarkStringifyOptionsCtx);
    ctx.set(remarkStringifyOptionsCtx, {
      ...prev,
      handlers: {
        ...prev.handlers,
        highlight: highlightMarkdownHandler,
      } as typeof prev.handlers,
      unsafe: [...(prev.unsafe ?? []), ...highlightMdastUnsafe],
    });
  });
}
